module.exports = __webpack_public_path__ + "static/img/10.f581f2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/10.jpg
// module id = e1yb
// module chunks = 1